import styled, { css } from "styled-components";
import { SNAP_MOBILE_MAX_PX } from "../../constants/breakpoints";

export const snapSectionFillStyles = css`
  width: 100%;
  flex: 1 1 auto;
  align-self: stretch;
  min-height: 100%;
`;

export const SnapSection = styled.section<{
  $overflowVisible?: boolean;
  $background?: string;
}>`
  width: 100%;
  flex: 0 0 100svh;
  height: 100svh;
  min-height: 100svh;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: ${({ $overflowVisible }) => ($overflowVisible ? "visible" : "hidden")};
  background-color: ${({ $background }) => $background ?? "transparent"};

  @supports (height: 100dvh) {
    flex-basis: 100dvh;
    height: 100dvh;
    min-height: 100dvh;
  }

  @media only screen and (max-width: ${SNAP_MOBILE_MAX_PX}px) {
    flex: 0 0 auto;
    height: auto;
    min-height: auto;
    scroll-snap-align: none;
    scroll-snap-stop: normal;
    overflow: visible;
    justify-content: flex-start;
  }
`;

export const KusariEndSection = styled(SnapSection)`
  flex: 0 0 auto;
  height: auto;
  min-height: 100svh;
  scroll-snap-align: end;
  justify-content: flex-start;
  align-items: stretch;
  overflow: visible;

  > * {
    flex: 1 1 auto;
    width: 100%;
    min-height: 100%;
  }
`;

export const HomeScrollRoot = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100svh;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  scroll-behavior: auto;
  overscroll-behavior-y: contain;
  background-color: var(--bg);
  -webkit-overflow-scrolling: touch;

  @supports (height: 100dvh) {
    min-height: 100dvh;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media only screen and (max-width: ${SNAP_MOBILE_MAX_PX}px) {
    height: auto;
    min-height: 100svh;
    overflow-y: visible;
    scroll-snap-type: none;
    overscroll-behavior-y: auto;

    @supports (height: 100dvh) {
      min-height: 100dvh;
    }
  }
`;

export const MobileOnly = styled.div`
  display: none;

  @media only screen and (max-width: ${SNAP_MOBILE_MAX_PX}px) {
    display: block;
    width: 100%;
  }
`;

export const DesktopOnly = styled.div`
  width: 100%;

  @media only screen and (max-width: ${SNAP_MOBILE_MAX_PX}px) {
    display: none;
  }
`;
